module.exports = __webpack_public_path__ + "static/media/adgate.ba3fc639.png";